import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`bgfx support many platform, let's see if we can embed it on this post...`}</p>
    <h1>{`Bgfx + Emscripten?`}</h1>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/bkaradzic/bgfx"
          }}>{`Bgfx`}</a>{` is a powerful rendering API help you to deal with lots of cross platform/low-level graphics API stuff!`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://emscripten.org/"
          }}>{`Emscripten`}</a>{` allows you code in familiar native language like C++ and compile it to WebAssembly (wasm) that runs in browser. There are some limitation of course but good thing about wasm is: your app can be accessed by anyone with modern browser (webgl).`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`WebGL & mobile graphics is the relative low end, if you manage to run on these platform, it also prove that it can run anywhere else.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`If you are believer of wasm ...`}</p>
      </li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://github.com/daizeng1984/bgfx.emscripten"
      }}>{`Here`}</a>{`'s code repo to compile a simple example from bgfx.`}</p>
    <h1>{`Tips`}</h1>
    <ol>
      <li parentName="ol">{`Using nix and direnv saved a lot of rampup works, if you are interested. Check out my previous `}<a parentName="li" {...{
          "href": "../2020-12-10-nix-power-2"
        }}>{`post`}</a>{`.`}</li>
      <li parentName="ol">{`BGFX can build wasm but failed to compile some examples, you need to compile wasm without example like `}<a parentName="li" {...{
          "href": "https://github.com/daizeng1984/bgfx.emscripten/blob/master/Makefile#L76"
        }}>{`this`}</a></li>
      <li parentName="ol">{`Emscripten provides virtual file system but you need to specify the path in configuration and use @: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`path@virtualpath`}</code></li>
      <li parentName="ol">{`To use emcc with webgl or glfw you need to treat specially instead of compile yourself. A bunch of `}<a parentName="li" {...{
          "href": "https://github.com/daizeng1984/bgfx.emscripten/blob/master/Makefile#L29"
        }}>{`flags`}</a>{` I have to add to make things work.`}</li>
      <li parentName="ol">{`shader and assets build requires tools build. You can write your own `}<a parentName="li" {...{
          "href": "https://github.com/daizeng1984/bgfx.make/blob/master/assets/Makefile"
        }}>{`make`}</a>{` or reuse `}<a parentName="li" {...{
          "href": "https://github.com/daizeng1984/bgfx.emscripten/blob/master/assets/build.ninja"
        }}>{`ninja script`}</a>{` from examples.`}</li>
      <li parentName="ol">{`To generate `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`compile_commands.json`}</code>{`, you can use `}<a parentName="li" {...{
          "href": "https://github.com/daizeng1984/bgfx.emscripten/blob/master/default.nix#L10"
        }}>{`compiledb`}</a>{`.`}</li>
      <li parentName="ol">{`To serve the local wasm html files, you can just `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`miniserve -p 9000`}</code>{` which is included in the nix or `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`emrun`}</code>{`.`}</li>
      <li parentName="ol">{`To debug the wasm, you need to add `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`-g`}</code>{` flag and use google-chrome browser with DWARF plugin (see `}<a parentName="li" {...{
          "href": "https://developer.chrome.com/blog/wasm-debugging-2020/"
        }}>{`here`}</a>{`). It's just this feature's still in beta version.`}</li>
    </ol>
    <p>{`If you have some patience and modern browser, you should be able to see the 3D bunny in the iframe below:`}</p>
    <div style={{
      "position": "relative",
      "width": "100%",
      "height": "0",
      "paddingBottom": "51%"
    }}>
      <iframe width="100%" style={{
        "position": "absolute",
        "width": "100%",
        "height": "100%",
        "left": "0",
        "top": "0"
      }} src="https://daizeng1984.bitbucket.io/assets/wasm/hdr/main.html" />
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      